import React, { useCallback, useState } from 'react';
import { Modal } from '@beef/ui-kit';
import { useDispatch, useSelector } from 'react-redux';

// Components
import { Popups } from 'components';
import { TarifficationOfLimits } from '../../components/TarifficationOfLimits';
import { CommonModalHOC } from '../CommonModalHOC';
import { CommonResultPopup } from '../../components/CommonResultPopup';
import { AddNumberFamilyHoc } from '../../hocs/AddNumberFamilyHOC';

// Utils
import { setPopupStatus } from '../../store/actions';

// Constants
import { POPUP_NAMES } from '../../constants';

const { AddNumberPopup } = Popups;

const FamilyConnectPopup = () => {
  const [invitingNumber, setInvitingNumber] = useState('');
  const { familyPopups, popupRequestStatus, content, isSeb } = useSelector((state) => state.family);
  const { isOpen, step } = familyPopups;
  const dispatch = useDispatch();

  const handleCloseModal = useCallback(() => {
    dispatch(setPopupStatus(false));
  }, []);

  const STEPS_FOR_COMMON_POPUP = [POPUP_NAMES.delete, POPUP_NAMES.deleteSuccess];

  // toggle для Пономерной Семьи
  if (content.familyNumberedPriceToggleEnabled && STEPS_FOR_COMMON_POPUP.includes(step)) {
    return (
      <CommonModalHOC />
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      isCentered
      onClose={handleCloseModal}
      size="s"
    >
      {(step === POPUP_NAMES.add) && (
        <AddNumberFamilyHoc setInvitingNumber={setInvitingNumber}>
          <AddNumberPopup />
        </AddNumberFamilyHoc>
      )}
      {step === POPUP_NAMES.terms && (
        <TarifficationOfLimits onClick={handleCloseModal} content={content?.popups?.tarifficationOfLimits} isSeb={isSeb} />
      )}
      {(step === POPUP_NAMES.addedSuccessfully
      || step === POPUP_NAMES.notFoundError
      || step === POPUP_NAMES.diffRegionError
      || step === POPUP_NAMES.error
      || step === POPUP_NAMES.cancelInvitation
      || step === POPUP_NAMES.saveLimits
      || step === POPUP_NAMES.limitsSavedSuccess
      || step === POPUP_NAMES.delete
      || step === POPUP_NAMES.deleteSuccess) && (
        <CommonResultPopup
          step={step}
          invitingNumber={invitingNumber}
          inProgress={popupRequestStatus.isLoading}
        />
      )}
    </Modal>
  );
};

export { FamilyConnectPopup };
